import { REQUEST_STATUS } from '../../../constants/request'
import { NUMBER_SIZE } from '../../../constants/size'
import { useInitData, useLinkLikeClick } from '../../../hooks'
import { getRequestProfilePathname } from '../../../utils/link'
import { EntityStatus } from '../../Entity'

import * as styles from './ServiceRequestsWidgetItemContent.module.css'

function ServiceRequestsWidgetItemContent({
  ContentContainer,
  profileLinkParams,
  status,
  value,
  ...restProps
}) {
  const { handleClick } = useLinkLikeClick()

  const { availableSections } = useInitData()

  function handleClickTitle(event) {
    handleClick({
      event,
      link: getRequestProfilePathname({
        additionalParams: profileLinkParams,
        availableSections,
        id: value,
      }),
    })
  }

  return (
    <ContentContainer {...restProps} onClickTitle={handleClickTitle}>
      <EntityStatus
        className={styles.status}
        height={NUMBER_SIZE.size20}
        id={status}
        statuses={REQUEST_STATUS}
      />
    </ContentContainer>
  )
}

export default ServiceRequestsWidgetItemContent
